import { Box, FormHelperText } from '@mui/material';
import { styled } from '@mui/material/styles';
import { withTheme, makeStyles } from '@mui/styles';
import styledComponent from 'styled-components';

export const Container = styled(Box)(
  ({ theme }) => `
  margin: 20px 248px;
  .btn {
    width: 270px;
    height: 60px;
    font-size: ${theme.typography.h4.fontSize}px;
  }
  ${theme.breakpoints.down('lg')} {
    margin: 20px;
  }
  ${theme.breakpoints.down('md')} {
    margin: 16px;
    .btn {
      width: 152px;
      height: 40px;
      font-size: ${theme.typography.h7.fontSize}px;
    }
    .btn.back {
      width: auto;
      padding: 0;
      color: ${theme.palette.primary.main};
    }
  }
`,
);

export const FormErrorText = styled(FormHelperText)(
  ({ theme }) => `
  color: ${theme.palette.errorDark.main};
  font-size: 16px;
  line-height: 1;
`,
);

export const CheckboxLabel = withTheme(styledComponent.div`
  font-size: 24px;
  line-height: 1;
  font-family: 'Lanna';
  display: flex;
  flex-direction: column;

  ${(props: any) => props.theme.breakpoints.up('sm')} {
    display: inline;

    >span:not(:last-child)::after {
      content: '\\a0';
    },
  }
`);

export const AcceptPolicyBox = styled(Box)(
  ({ theme }) => `
  position: sticky;
  mergin-top: auto;
  bottom: 70px;
  background-color: #fff;
  height: 152px;
  width: 100%;
  box-shadow: 0px -2px 9px rgb(0 0 0 / 12%);

  &.error {
    height: 192px;
  }

  ${theme.breakpoints.up('sm')} {
    height: 96px;

    &.error {
      height: 140px;
    }
  }

  ${theme.breakpoints.up('md')} {
    bottom: 100px;
    height: 80px;
    margin-top: auto;

    &.error {
      height: 104px;
    }
  }
  `,
);

export const LinkText = withTheme(styledComponent.a`
  color: ${(props: any) => props.theme.palette.primary.main};
  text-decoration: underline;
  font-size: 24px;
  line-height: 1;
  font-family: 'Lanna';
`);

export const useStyles = makeStyles((theme: any) => ({
  label: {
    lineHeight: 1,
  },
}));
